//@flow
import type { CampaignExpiredNotification } from '../notification/actions'
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Modal } from '../../common-components'

type CampaignExpiredProps = {
  notificationMessage: CampaignExpiredNotification,
  onExit: Function,
}

const Warning = styled.p`
  color: red;
`

export const _CampaignExpiredPopup = ({ notificationMessage, onExit, backToHome, ...props }: CampaignExpiredProps) => (
  <Modal
    isOpen={notificationMessage !== 'None'}
    backdrop={true}
    size="lg"
    modalClassName="default-bootstrap remote-selling-modal"
    toggle={() => {
      onExit()
    }}
  >
    <ModalHeader
      toggle={() => {
        onExit()
      }}
    >
      กรุณาตรวจสอบข้อมูล
    </ModalHeader>
    <ModalBody>
      <p>{notificationMessage.message}</p>
      <Warning>{notificationMessage.warningmessage}</Warning>
    </ModalBody>
    <ModalFooter>
      <div className="bottom">
        <Button
          color="outline-primary"
          onClick={() => {
            onExit()
          }}
        >
          ปิด
        </Button>
      </div>
    </ModalFooter>
  </Modal>
)

export default withRouter(connect(null, null)(_CampaignExpiredPopup))
